import { render } from "./rawMaterialList.vue?vue&type=template&id=2f961da8&ts=true"
import script from "./rawMaterialList.vue?vue&type=script&lang=ts"
export * from "./rawMaterialList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__